export const queryKeys = {
  USE_TOPIC_TEST: 'use-topic-tests',
  USE_TOPIC_TEST_BY_ID: 'use-topic-tests-by-id',
  USE_FINISH_TEST: 'use-finish-test',
  USE_MY_RESULT: 'use-my-result',
  USE_TOPIC_TEST_INFO: 'use-topic-test-info',
  USE_TOPIC_TEST_QUIZ: 'use-topic-test-quiz',
};
